export default {
    'supportComment': {
        en: 'Música para Respirar 24/7 is made possible thanks to the generous support of:',
        es: 'Música para Respirar 24/7 es posible gracias al apoyo de:',
        pt: 'Música para Respirar 24/7 é possível graças ao apoio de'
    },
    'INDIVIDUAL CONTRIBUTORS': {
        en: 'INDIVIDUAL CONTRIBUTORS FROM GOFUNDME',
        es: 'CONTRIBUYENTES INDIVIDUALES DE GOFUNDME',
        pt: 'CONTRIBUINTES INDIVIDUAIS DA GOFUNDME'
    },
    'SUPPORTERS': {
        en: "SUPPORTERS",
        es: "APOYO",
        pt: 'APOIO'
    },
    'and': {
        en: 'and',
        es: 'y',
        pt: 'e'
    }
}
